import { useEffect, useState } from "react";
import api from "../../services/api";

/* ================= COLORS ================= */
const COLORS = {
  primary: "#2563EB",
  bg: "#F3F4F6",
  card: "#FFFFFF",
  border: "#E5E7EB",
  text: "#111827",
  muted: "#6B7280",
};

const Company = () => {
  const [form, setForm] = useState({
    name: "",
    owner: "",
    phone: "",
    address: "",
  });

  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);
  const [hasCompany, setHasCompany] = useState(false);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await api.get("/company/get.php");
    if (res.data.success && res.data.data) {
      setForm(res.data.data);
      setHasCompany(true);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post("/company/update.php", form);
      setEditing(false);
      setHasCompany(true);
    } catch {
      alert("Error saving");
    }

    setLoading(false);
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>
            Company Profile
          </h2>
          <div style={styles.subtitle}>
            Manage your business information
          </div>
        </div>

        {hasCompany && !editing && (
          <button
            style={styles.primaryBtn}
            onClick={() => setEditing(true)}
          >
            Edit Company
          </button>
        )}
      </div>

      {/* VIEW MODE */}
      {hasCompany && !editing && (
        <div style={styles.card}>
          <DetailRow label="Company Name" value={form.name} />
          <DetailRow label="Owner Name" value={form.owner} />
          <DetailRow label="Phone" value={form.phone} />
          <DetailRow label="Address" value={form.address} />
        </div>
      )}

      {/* EDIT / CREATE MODE */}
      {(!hasCompany || editing) && (
        <form onSubmit={submit} style={styles.card}>
          <FormField
            label="Company Name"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <FormField
            label="Owner Name"
            name="owner"
            value={form.owner}
            onChange={handleChange}
          />

          <FormField
            label="Phone"
            name="phone"
            value={form.phone}
            onChange={handleChange}
          />

          <div style={styles.field}>
            <label style={styles.label}>
              Address
            </label>
            <textarea
              name="address"
              value={form.address}
              onChange={handleChange}
              style={{
                ...styles.input,
                height: 90,
              }}
            />
          </div>

          <div style={styles.actions}>
            {editing && (
              <button
                type="button"
                style={styles.cancelBtn}
                onClick={() =>
                  setEditing(false)
                }
              >
                Cancel
              </button>
            )}

            <button
              type="submit"
              style={styles.primaryBtn}
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : "Save Company"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

/* ===== COMPONENTS ===== */

const DetailRow = ({ label, value }) => (
  <div style={styles.row}>
    <div style={styles.rowLabel}>
      {label}
    </div>
    <div style={styles.rowValue}>
      {value || "-"}
    </div>
  </div>
);

const FormField = ({
  label,
  name,
  value,
  onChange,
  required,
}) => (
  <div style={styles.field}>
    <label style={styles.label}>
      {label}
    </label>
    <input
      name={name}
      value={value}
      onChange={onChange}
      style={styles.input}
      required={required}
    />
  </div>
);

/* ===== STYLES ===== */

const styles = {
  page: {
    padding: 30,
    background: COLORS.bg,
    minHeight: "100vh",
  },

  header: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems: "center",
    marginBottom: 24,
  },

  title: {
    fontSize: 22,
    fontWeight: 600,
    color: COLORS.text,
  },

  subtitle: {
    fontSize: 14,
    color: COLORS.muted,
    marginTop: 4,
  },

  card: {
    background: COLORS.card,
    borderRadius: 16,
    border: `1px solid ${COLORS.border}`,
    padding: 24,
    maxWidth: 700,
  },

  row: {
    display: "grid",
    gridTemplateColumns:
      "220px 1fr",
    padding: "14px 0",
    borderBottom: `1px solid ${COLORS.border}`,
  },

  rowLabel: {
    fontWeight: 500,
    color: COLORS.text,
  },

  rowValue: {
    color: COLORS.muted,
  },

  field: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 16,
  },

  label: {
    fontSize: 13,
    marginBottom: 6,
    color: COLORS.muted,
  },

  input: {
    padding: "8px 10px",
    borderRadius: 6,
    border: `1px solid ${COLORS.border}`,
    fontSize: 14,
    outline: "none",
  },

  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
    marginTop: 12,
  },

  primaryBtn: {
    background: COLORS.primary,
    color: "#fff",
    padding: "8px 16px",
    borderRadius: 8,
    border: "none",
    fontWeight: 500,
    cursor: "pointer",
  },

  cancelBtn: {
    background: "#E5E7EB",
    padding: "8px 16px",
    borderRadius: 8,
    border: "none",
    cursor: "pointer",
  },
};

export default Company;